export default function useCurrentUser() {
  const serializedUser = localStorage.getItem('usuario');
  return JSON.parse(serializedUser);
}
